module.exports = __webpack_public_path__ + "img/quizz-step-1-3.a5a79169.jpg";